var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "gesture-preview", class: { opened: _vm.opened } },
    [
      _c("div", { staticClass: "gesture-preview-content" }, [
        _c(
          "div",
          { staticClass: "brightness" },
          [
            _c("ProgressRing", {
              attrs: { size: 100, progress: _vm.preview.brightness * 100 },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _c("div", { staticClass: "name" }, [_vm._v("亮度")]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("percent")(_vm.preview.brightness)) +
                    "\n        "
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "progress" }, [
          _c("div", { staticClass: "videoshot", style: _vm.videoshotStyle }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.preview.progress !== null,
                  expression: "preview.progress !== null",
                },
              ],
              staticClass: "preview",
            },
            [
              !_vm.progressNaN
                ? _c("div", { staticClass: "diff" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("progressDiff")(
                            _vm.preview.progress - _vm.store.progress
                          )
                        ) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "seek-mode" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      !_vm.progressNaN ? _vm.preview.seekMode : "取消调整"
                    ) +
                    "\n        "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.preview.progress === null,
                  expression: "preview.progress === null",
                },
              ],
              staticClass: "name",
            },
            [_vm._v("进度")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "progress-label" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("progress")(
                    _vm.progressValid
                      ? _vm.preview.progress
                      : _vm.store.progress
                  )
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "volume" },
          [
            _c("ProgressRing", {
              attrs: { size: 100, progress: _vm.preview.volume * 100 },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _c("div", { staticClass: "name" }, [_vm._v("音量")]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("percent")(_vm.preview.volume)) +
                    "\n        "
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "progress-bar" },
        [
          _c("ProgressBar", {
            attrs: {
              progress: _vm.progressValid
                ? _vm.preview.progress
                : _vm.store.progress,
              max: _vm.video.duration,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }